import Editor from "@monaco-editor/react";
import React, { useEffect, useRef, useState } from "react";

const CodeEditor = ({ getHtml, html, editType }) => {
  const defaultTheme = "vs-light";
  const [code, setCode] = useState(
    '<!DOCTYPE html><html>\n<head>\n<title>\n</title>\n<meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">\n</head>\n<body>\n</body>\n</html>'
  );
  const [theme, setTheme] = useState(
    localStorage.getItem("editorTheme") || defaultTheme
  );
  const editorRef = useRef(null);

  const handleEditorChange = (value, event) => {
    setCode(value);
    getHtml(value);
  };

  const handleEditorDidMount = (editor, monacoInstance) => {
    editorRef.current = editor;
    monacoInstance.editor.setTheme(theme);

    monacoInstance.languages.registerCompletionItemProvider("html", {
      provideCompletionItems: () => {
        const suggestions = [
          {
            label: "html:5",
            kind: monacoInstance.languages.CompletionItemKind.Snippet,
            insertText: `<!DOCTYPE html>
                              <html>
                              <head>
                                <title></title>
                                <meta charset="UTF-8">
                                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              </head>
                              <body>

                              </body>
                              </html>`,
            insertTextRules:
              monacoInstance.languages.CompletionItemInsertTextRule
                .InsertAsSnippet,
            documentation: "Basic HTML5 template",
          },
          {
            label: "div.container",
            kind: monacoInstance.languages.CompletionItemKind.Snippet,
            insertText: `<div class="container">\n\t$0\n</div>`,
            insertTextRules:
              monacoInstance.languages.CompletionItemInsertTextRule
                .InsertAsSnippet,
            documentation: "div with class container",
          },
          {
            label: "a",
            kind: monacoInstance.languages.CompletionItemKind.Keyword,
            insertText: '<a href="$0"></a>',
            insertTextRules:
              monacoInstance.languages.CompletionItemInsertTextRule
                .InsertAsSnippet,
            documentation: "Anchor tag",
          },
          {
            label: "img",
            kind: monacoInstance.languages.CompletionItemKind.Keyword,
            insertText: '<img src="$0" alt=""/>',
            insertTextRules:
              monacoInstance.languages.CompletionItemInsertTextRule
                .InsertAsSnippet,
            documentation: "Image tag",
          },
        ];
        return { suggestions: suggestions };
      },
    });

    monacoInstance.languages.html.htmlDefaults.setOptions({
      suggest: {
        html5: true,
        angular1: true,
        bootstrap: true,
      },
    });
  };

  const handleThemeChange = (e) => {
    const newTheme = e.target.value;
    setTheme(newTheme);
    if (editorRef.current) {
      editorRef.current.updateOptions({ theme: newTheme });
    }
    localStorage.setItem("editorTheme", newTheme);
  };

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.updateOptions({ theme: theme });
    }
  }, [theme]);

  return (
    <div>
      <select
        value={theme}
        onChange={handleThemeChange}
        style={{ marginBottom: "10px" }}
      >
        <option value="vs-dark">Dark</option>
        <option value="vs-light">Light</option>
        <option value="hc-black">High Contrast Black</option>
        <option value="hc-light">High Contrast Light</option>
      </select>
      <Editor
        height="50vh"
        defaultLanguage="html"
        value={editType === true ? html : code}
        onChange={handleEditorChange}
        onMount={handleEditorDidMount}
        options={{
          selectOnLineNumbers: true,
          roundedSelection: false,
          readOnly: false,
          cursorStyle: "line",
          automaticLayout: true,
          minimap: { enabled: false },
          lineNumbers: "off",
        }}
      />
    </div>
  );
};

export default CodeEditor;
